import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {ModalService} from '../../../shared/services/modal.service';
import {AdminService} from '../../../shared/services/admin.service';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {ModalAdminAccountComponent} from '../../admin-accounts/modal-admin-account/modal-admin-account.component';
import {catchError} from 'rxjs/operators';
import {empty} from '../../../functions';
import {RoleTypes} from '../../../guards/roletypes';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';

@Component({
    selector: 'app-admin-company-accounts',
    templateUrl: './admin-company-accounts.component.html',
    styleUrls: ['./admin-company-accounts.component.scss'],
    standalone: false
})
export class AdminCompanyAccountsComponent implements OnInit {

  filterOpen = true;

  public RoleTypes = RoleTypes;

  public view = {
    filters: {
      queryParams: {
        SearchTerm: null,
        SortField: 'emailAddress',
        SortType: 'Ascending',
        Role: RoleTypes.Company
      }
    },
    filterOptions: {
      areaOfInterests: <any>[],
      sites: <any>[],
      status: <any>[],
      educationLevels: <any>[],
    },

  };

  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: 'Email',
        name: 'emailAddress',
        type: 'text'
      },
      {
        header_name: 'First name',
        name: 'firstName',
        type: 'text'
      },
      {
        header_name: 'Last name',
        name: 'lastName',
        type: 'text'
      },
      {
        header_name: marker('Roles'),
        name: 'roles',
        type: 'array',
        field: ''
      },
    ],
    endpoint: 'account',
    data: <any> [],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-info',
        event: 'make-company-election-owner',
        text: marker('Make company election admin'),
        closure: function(row: any): boolean
        {
          return (row.hasOwnProperty('roles') && !row.roles.includes(RoleTypes.BedrijfsVerkiezingsbeheerder)) ? true : false;
        }
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject(),
    queryParams: this.view.filters.queryParams
  };

  /**
   * Constructor
   *
   * @param modal
   * @param adminService
   * @param alertService
   */
  constructor(
    public modal:ModalService,
    public adminService: AdminService,
    private alertService: AlertService
  ) {

  }

  /**
   * Ng on init
   */
  ngOnInit(): void {


  }

  /**
   * Add a single account
   */
  addAccount() {

    const data = {
      emailAddress: '',
      firstName: '',
      lastName: ''
    };
    const modalOptios = {
      backdrop: 'static',
      size: 'xl'
    }
    this.modal.Modal(ModalAdminAccountComponent, 'Account', '', data, [], modalOptios).then( (result) => {

      if (result === true) {

        this.alertService.success(alertMessages.successDataSaved);

        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });
  }

  /**
   * Update a single account
   *
   * @param $account
   */
  updateAccount($account: any) {

    const data = $account;

    const modalOptios = {
      backdrop: 'static',
      size: 'xl'
    }
    this.modal.Modal(ModalAdminAccountComponent, 'Account', '', data, [], modalOptios).then( (result) => {

      if (result === true) {
        this.alertService.success(alertMessages.successDataSaved);

        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });
  }

  makeAccountCompanyElectionOwner($account: any)
  {
    if (!$account.hasOwnProperty('id')) return;

    this.modal.Confirm('', marker('Are you sure?')).then( (result) => {

      if (result == true) {

        $account.roles.push(RoleTypes.BedrijfsVerkiezingsbeheerder);

        this.adminService.apiUpdateAccount($account).subscribe( (response) => {

          this.configTable.reloadListener.next(true);

        });
      }

    });

  }

  /**
   * Delete a single account
   *
   * @param $id
   */
  deleteAccount($id: string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then((confirm) => {

      if (confirm === true) {

        this.adminService.apiDeleteAccount($id).pipe(catchError(this.adminService.handleError('apiDeleteAccount', false))).subscribe( (result) => {

          if (result !== false) {
            this.alertService.success(alertMessages.successDataRemoved);
            this.configTable.reloadListener.next(true);
          }

        });

      }
      else {

      }
    }).catch((error) => {

    });
    this.adminService.apiDeleteAccount($id)
  }

  /**
   * Handle table button event
   *
   * @param $event
   */
  handleButtonEvent($event:any) {

    if (!empty($event['event'])) {

      switch ($event['event']) {

        case 'edit':
          this.updateAccount($event['data']);
          break;

        case 'make-company-election-owner':
          this.makeAccountCompanyElectionOwner($event['data']);
          break;

        case 'delete':
          this.deleteAccount($event['data']['id']);
          break;
      }
    }

  }

  reloadData() {

    this.setQueryParams();

    this.configTable.reloadListener.next(true);
  }

  setQueryParams() {
    this.configTable.queryParams = this.view.filters.queryParams
  }

  resetFilters() {

    this.view.filters = {
      queryParams: {
        SearchTerm: null,
        SortField: 'createdOn',
        SortType: 'Descending',
        Role: RoleTypes.Company,
      }
    }

    this.reloadData();
  }

  applyFilters()
  {
    this.reloadData();
  }

}
